export const ROUTER_INTENT_NONE = 'root';
export const ROUTER_INTENT_FORWARD = 'forward';
export const ROUTER_INTENT_BACK = 'back';
